export class SafeStorage {
  static setItem(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      if (e instanceof DOMException) {
        if (e.name === 'QuotaExceededError') {
          console.warn('localStorage quota exceeded');
          this.clearOldItems();
        } else if (e.name === 'SecurityError') {
          console.warn('localStorage not available (private browsing mode)');
        }
      }
      return false;
    }
  }

  static getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('localStorage read failed:', e);
      return null;
    }
  }

  static removeItem(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn('localStorage remove failed:', e);
      return false;
    }
  }

  static clearOldItems(): void {
    const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && key.startsWith('clarification-')) {
          const timestamp = localStorage.getItem(key);
          if (timestamp && parseInt(timestamp, 10) < thirtyDaysAgo) {
            localStorage.removeItem(key);
          }
        }
      }
    } catch (e) {
      console.warn('Failed to clear old items from localStorage:', e);
    }
  }
}

export class SafeSessionStorage {
  static setItem(key: string, value: string): boolean {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      if (e instanceof DOMException) {
        if (e.name === 'QuotaExceededError') {
          console.warn('sessionStorage quota exceeded');
        } else if (e.name === 'SecurityError') {
          console.warn('sessionStorage not available (private browsing mode)');
        }
      }
      return false;
    }
  }

  static getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      console.warn('sessionStorage read failed:', e);
      return null;
    }
  }

  static removeItem(key: string): boolean {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn('sessionStorage remove failed:', e);
      return false;
    }
  }
}
